export const variantMatches = (variant, ...anyof) => {
    if (typeof variant === 'string' && anyof.includes(variant))
        return true;
    if (Array.isArray(variant) && variant.some((v) => anyof.includes(v))) {
        return true;
    }
    return false;
};
//# sourceMappingURL=variantMatches.js.map
